import { render, staticRenderFns } from "./OwnerBannerComponent.vue?vue&type=template&id=cb74e424"
import script from "./OwnerBannerComponent.vue?vue&type=script&lang=js"
export * from "./OwnerBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./OwnerBannerComponent.vue?vue&type=style&index=0&id=cb74e424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports